import { Badge, Typography } from "@mui/material";

import { useAnnounceKit } from "../../../utils/announcekit/announcekitHooks";

export const WhatsNewButtonWrapper = () => {
  const { openAnnounceKit, unread } = useAnnounceKit();

  return (
    <Badge
      variant="dot"
      sx={{
        "& .MuiBadge-dot": {
          backgroundColor: "#CAD2FF",
        },
      }}
      invisible={!unread}
    >
      <Typography
        id="whatsNew-button"
        data-cy="item-5"
        sx={{
          color: "navigation.subItemColor",
          my: 0.5,
          flex: 1,
          m: -2,
          p: 2,
        }}
        variant="body2"
        onClick={openAnnounceKit}
      >
        What's new
      </Typography>
    </Badge>
  );
};
